// extracted by mini-css-extract-plugin
module.exports = {"container":"GOLCell_container__e9kiS","alive":"GOLCell_alive__ihvPk"};